import { render } from "./index.vue?vue&type=template&id=4cabe6c4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4cabe6c4&lang=less"
script.render = render

export default script